import DocumentBuilder from 'components/editor/DocumentBuilder/DocumentBuilder';
import { SignaturesProvider } from 'components/editor/providers/SignaturesProvider';
import { SocketProvider } from 'providers/SocketContext';
import { SelectedBlockInfoProvider } from 'components/editor/GridDndEditor/SelectedBlockInfoProvider';
import { EditorConfigProvider } from 'components/editor/GridDndEditor/Block/Text/EditorConfigs';
import TextDefaultStylesLoader from 'components/editor/TextDefaultStylesLoader/TextDefaultStylesLoader';
import TableRowDefaultStylesLoader from 'components/editor/TableRowDefaultStylesLoader/TableRowDefaultStylesLoader';
import { LiveblocksProvider } from 'providers/LiveblocksProvider';
import { ContentType } from 'utils/getContentType';
import DocumentLockedModal from 'components/editor/modals/DocumentLockedModal';
import { StorePreloader } from 'components/editor/grid/reduxStore/StorePreloader';

interface Props {
  contentId: string;
  contentType: ContentType;
}

export function EditorContentWrapper({ contentId, contentType }: Props) {
  return (
    <SocketProvider contentId={contentId}>
      <StorePreloader contentId={contentId} contentType={contentType}>
        {contentType === ContentType.DOCUMENT && <DocumentLockedModal />}
        <LiveblocksProvider contentId={contentId} contentType={contentType}>
          <SignaturesProvider contentType={contentType}>
            <SelectedBlockInfoProvider>
              <EditorConfigProvider>
                <>
                  <TextDefaultStylesLoader />
                  <TableRowDefaultStylesLoader />
                  <DocumentBuilder />
                </>
              </EditorConfigProvider>
            </SelectedBlockInfoProvider>
          </SignaturesProvider>
        </LiveblocksProvider>
      </StorePreloader>
    </SocketProvider>
  );
}
